import { render, staticRenderFns } from "./GiftRoom.vue?vue&type=template&id=71410694&scoped=true"
import script from "./GiftRoom.vue?vue&type=script&lang=js"
export * from "./GiftRoom.vue?vue&type=script&lang=js"
import style0 from "./GiftRoom.vue?vue&type=style&index=0&id=71410694&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71410694",
  null
  
)

export default component.exports